var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExt1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 153,
    viewBox: "0 0 153 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.6309 89.8734C91.5354 87.2704 99.9379 84.126 102.312 92.3723",
    stroke: "#E68764",
    strokeWidth: 6.2472,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1836 75.2975C85.8907 71.7574 93.8351 65.833 103.956 70.4559",
    stroke: "#E69A64",
    strokeWidth: 6.2472,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6836 54.6168L105.742 49.4629",
    stroke: "#E68764",
    strokeWidth: 6.2472,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0195 54.6158C81.6117 51.8566 86.6407 43.8706 78.0195 34",
    stroke: "#E69A64",
    strokeWidth: 6.2472,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5614 59.9251C61.9453 54.9274 65.3397 45.4941 51.8457 47.7431",
    stroke: "#E68764",
    strokeWidth: 6.2472,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5175 98.2668L49.0185 71.6302L47.2862 78.0235L65.3734 100.433L70.5175 98.2668Z",
    fill: "#EFC8AB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8237 102.799L45.4113 84.9428L45.1732 85.8217L43.6229 91.2666L54.698 104.988L59.8237 102.799Z",
    fill: "#EFC8AB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9111 109.595L49.0368 107.406L41.6376 98.2389L39.8403 104.552L43.9111 109.595Z",
    fill: "#EFC8AB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.7497 68.9316C49.7497 68.9316 61.7939 69.3433 68.4673 78.045C75.1407 86.7467 76.0477 95.9379 76.0477 95.9379L70.5175 98.2668L49.0185 71.6302L49.7497 68.9316ZM65.3734 100.433L47.2862 78.0235L45.4113 84.9428L59.8237 102.799L64.6999 100.717L65.3734 100.433ZM43.6229 91.2666L54.698 104.988L49.0368 107.406L41.6376 98.2389L43.6229 91.2666ZM43.9111 109.595L39.8403 104.552L37.6418 112.273L43.9111 109.595Z",
    fill: "#E68264"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExt1);
export default __webpack_public_path__ + "static/media/ext-1.e19c9c016a53952c8b8c7c288d33b8ca.svg";
export { ForwardRef as ReactComponent };